module.exports = __webpack_public_path__ + "img/stats_students.d5dab325.svg";